import React from 'react';
import { Box, makeStyles, TableRow, TableCell } from '@material-ui/core';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import TitleText from './TitleText';
import spice from '../../assets/images/spice.gif';
const useStyles = makeStyles(() => ({
	optionsIcon: {
		height: 25,
		width: 25,
		backgroundColor: '#FDE8EE',
		padding: 3,
		borderRadius: '50%',
	},
	tableCell: {
		fontSize: 12,
		fontWeight: 600,
	},
	img: {
		'& .MuiAvatar-img': {
			width: 30,
			height: 30,
		},
	},
}));
const FlightDealRow = ({ item, rowIndex }) => {
	const classes = useStyles();
	const history = useHistory();

	return (
		<>
			<TableRow key={rowIndex} style={{ marginTop: 20 }}>
				<TableCell className={classes.tableCell}>14 Mar 2022</TableCell>
				<TableCell className={classes.tableCell}>BLR - CCU</TableCell>
				<TableCell className={classes.tableCell}>
					<img src={spice}></img>
				</TableCell>
				<TableCell className={classes.tableCell}>I5 -1321</TableCell>
				<TableCell className={classes.tableCell}>06:30 PM</TableCell>
				<TableCell className={classes.tableCell}>09:05 PM</TableCell>
				<TableCell className={classes.tableCell}>TM 3800</TableCell>
				<TableCell className={classes.tableCell}>gedf</TableCell>
				<TableCell className={classes.tableCell}>
					<Box
						style={{
							color: 'white',
							background: 'darkblue',
							padding: '6px',
							textAlign: 'center',
							borderRadius: '5px',
						}}>
						<TitleText>Book Now</TitleText>
					</Box>
				</TableCell>
			</TableRow>
		</>
	);
};

export default FlightDealRow;
